export const tableColumnFieldPathOptions = {
	includeConstrainedFields: false,
	includeListRelationFields: false,
	includeListRelationTerminalFields: true,
	terminal: 'primitive-or-relation',
} as const;
